import { useState } from 'react';
import { SupportDialog } from '@/features/support/SupportDialog';

function readEnv(value: string | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

export function Footer() {
  const [supportOpen, setSupportOpen] = useState(false);
  // Read at render time (not module scope) so the values follow the build env.
  const phone = readEnv(import.meta.env.VITE_SUPPORT_PHONE);
  const email = readEnv(import.meta.env.VITE_SUPPORT_EMAIL);

  return (
    <footer className="h-11 shrink-0 border-t border-border/20 bg-rail px-5 py-2.5">
      <div className="flex h-full flex-wrap items-center gap-x-6 gap-y-1">
        {(phone || email) && <span className="db-label shrink-0">Техническая поддержка</span>}
        {phone && (
          <a
            href={`tel:${phone.replace(/[^+\d]/g, '')}`}
            className="shrink-0 text-xs text-muted-foreground hover:text-foreground"
          >
            {phone}
          </a>
        )}
        {email && (
          <a
            href={`mailto:${email}`}
            className="shrink-0 text-xs text-muted-foreground hover:text-foreground"
          >
            {email}
          </a>
        )}
        <button
          type="button"
          onClick={() => setSupportOpen(true)}
          className="shrink-0 text-xs text-primary hover:underline"
        >
          Написать в поддержку
        </button>
        <span className="ml-auto shrink-0 text-xs text-outline-faint">
          © {new Date().getFullYear()} DriveBase · Версия системы {__APP_VERSION__}
        </span>
      </div>

      {/* Mounted only while open: the dialog needs react-query, the footer itself does not. */}
      {supportOpen && <SupportDialog open onOpenChange={setSupportOpen} />}
    </footer>
  );
}
